<template>
  <div class="col-1-1">
    <div class="banner col-1-1 no-p">
      <div class="content flex flex-column justify-center">
        <h3>{{ content.title }}</h3>
        <div
          class="text mt-lg mb-lg"
          v-html="content.text"
        />
        <UIContentblockButton
          v-if="content.linkObject"
          class="btn-primary"
          :name="content.linkObject?.name"
          :link="content.linkObject?.link"
          :target="content.linkObject?.target"
        />
      </div>
      <div class="img-container">
        <BaseImage
          class="image"
          :media-object="content.imageObject"
          :sizes="{ md: 800 }"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { EventOverviewBannerContent } from '@/types/contentblocks'

  const props = defineProps<{
    content: EventOverviewBannerContent
  }>()
</script>
<style lang="scss" scoped>
  .banner {
    display: flex;
    gap: var(--padding-xxlg);
    background-color: $accent;
    border-radius: var(--border-radius-lg);
    padding: var(--padding-lg);
  }

  .content {
    flex: 1;
    min-width: 0;

    :deep(.btn-primary) {
      align-self: flex-start;
    }
  }

  .img-container {
    position: relative;
    flex-shrink: 0;
    width: 33.33%;
    height: 24rem;
    border-radius: var(--border-radius-md);
    overflow: hidden;

    :deep(.image) {
      width: 100%;
      height: 100%;
    }

    :deep(.image-wrapper) {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  @include media(sm) {
    .banner {
      flex-direction: column;
    }

    .img-container {
      width: 100%;
      height: 27rem;
    }
  }
</style>
